import { CLIColorLogger } from './cli-logger'
import { LambdaLoggerAdapter } from './lambda-logger'
import { Logger } from './logging'

export function getLogger(): Logger {
	// Check if running in AWS Lambda (you can check for `AWS_LAMBDA_FUNCTION_NAME` environment variable)
	if (process.env.AWS_LAMBDA_FUNCTION_NAME) {
		return new LambdaLoggerAdapter()
	}

	// Otherwise, assume it's the CLI
	return new CLIColorLogger()
}
